import { useEffect, useState } from "react";
import { apiFetch } from "../api/apiClient";

export default function useDashboard() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function cargar() {
            try {
                const resumen = await apiFetch("/api/dashboard/resumen");
                const flujoCaja = await apiFetch("/api/dashboard/flujo-caja");
                const gastosCategoria = await apiFetch("/api/dashboard/gastos-categoria");
                const alertas = await apiFetch("/api/dashboard/alertas");
                const vencimientos = await apiFetch("/api/dashboard/vencimientos");

                setData({
                    ...resumen,
                    flujoCaja,
                    gastosCategoria,
                    alertas,
                    vencimientos,
                });
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }

        cargar();
    }, []);

    return { data, loading };
}